import isEmpty from 'lodash/isEmpty';

import { get } from 'utils/lodash';

import { DEFAULT_LOCALE } from 'settings/constants/language';

export const getThemeMap = (theme, key) => {
  const themes = new Map(theme);
  return themes.get(key);
};

export const getCustomerProfile = customerProfile => {
  const displayName = get(customerProfile, 'userDisplayName', '');
  const fullname = get(customerProfile, 'userName', '');

  return {
    fullname,
    displayName,
    userId: get(customerProfile, 'userId', ''),
    userDob: get(customerProfile, 'userDobBrd', ''),
    language: get(customerProfile, 'language', DEFAULT_LOCALE),
    headerImageLink: get(customerProfile, 'headerImageLink', ''),
    greetingName: isEmpty(displayName) ? fullname : displayName,
  };
};

export const getTacDetail = detail => ({
  tacTimestamp: get(detail, 'tacSentDateTime', ''),
  isTacRequestSuccess: get(detail, 'isSuccess', false),
});

export const getImageSubmitPayload = ({ userId, tacValue, tacResult, state, images }) => {
  const selectedImage = get(state, 'selectedImage', '');
  const securityImage = images.find(image => image.value === selectedImage);
  return {
    userId,
    tacValue,
    securityImage: get(securityImage, 'key', ''),
    restSMSService: get(tacResult, 'tacViewBean.restSMSService', {}),
  };
};

export const getRemoveDevicePayload = ({ userId, tacValue, tacResult, state }) => {
  const customerKeyList = get(state, 'checkedValueTableRemoveDevice', []);
  return {
    userId,
    tacValue,
    restSMSService: get(tacResult, 'tacViewBean.restSMSService', {}),
    customerKeyList,
  };
};
